import { config, library } from '@fortawesome/fontawesome-svg-core'

import {
  faCog,
  faWindowMinimize,
  faUserSecret,
  faUserAstronaut,
  faPencil,
  faSave,
  faTimes,
  faAngleDown,
  faAngleUp,
  faAngleRight,
  faAngleLeft,
  faAngleDoubleRight,
  faPlay,
  faPlayCircle,
  faVolume,
  faHeart,
  faCheck,
  faComment,
  faUser,
  faChevronRight,
  faChevronDown,
  faChevronUp,
  faComments,
  faThumbsUp,
  faThumbsDown,
  faBullhorn,
  faLightbulb,
  faVoicemail,
  faGamepad,
  faVideo,
  faRobot,
  faCaretDown,
  faArrowLeft,
  faArrowRight,
  faArrowUp,
  faArrowDown,
  faPlus,
  faTransgender,
  faMusic,
  faBars,
  faGlobe,
  faFileUpload,
  faCircle,
  faClock,
  faDollarSign,
  faMicrophoneAlt,
  faInbox,
  faEye,
  faEuroSign,
  faShare,
  faTrash,
  faShoppingBasket,
  faSearch,
  faDownload,
  faSortAmountDown,
  faSlidersH,
  faFlag,
  faRedo,
  faExternalLink,
  faSignOut,
  faSignIn,
  faSpinnerThird,
  faThList,
  faThLarge,
} from '@fortawesome/pro-regular-svg-icons'

import { faCircleCheck } from '@fortawesome/free-regular-svg-icons'

import {
  faFire as faFireSolid,
  faPlay as faPlaySolid,
  faPause as faPauseSolid,
  faLongArrowAltRight as faLongArrowAltRightSolid,
  faLongArrowAltLeft as faLongArrowAltLeftSolid,
  faLongArrowAltUp as faLongArrowAltUpSolid,
  faLongArrowAltDown as faLongArrowAltDownSolid,
  faClock as faClockSolid,
  faHeart as faHeartSolid,
  faEllipsisH as faEllipsisHSolid,
  faCircle as faCircleSolid,
  faStar as faStarSolid,
  faArrowUp as faArrowUpSolid,
  faWrench as faWrenchSolid,
  faThumbsUp as faThumbsUpSolid,
  faThumbsDown as faThumbsDownSolid,
  faChild as faChildSolid
} from '@fortawesome/pro-solid-svg-icons'

import {
  faSearch as faSearchSolid,
} from '@fortawesome/free-solid-svg-icons'

import {
  faCcVisa,
  faCcMastercard,
  faCcDiscover,
  faCcAmex,
  faCcPaypal,
} from '@fortawesome/free-brands-svg-icons'

config.autoAddCss = false

library.add(
  faSearchSolid,
  faTimes,
  faAngleDown,
  faAngleUp,
  faAngleRight,
  faAngleLeft,
  faClockSolid,
  faClock,
  faPlay,
  faPlayCircle,
  faVolume,
  faHeart,
  faCheck,
  faComment,
  faUser,
  faChevronRight,
  faComments,
  faThumbsUp,
  faThumbsDown,
  faThumbsUpSolid,
  faThumbsDownSolid,
  faBullhorn,
  faLightbulb,
  faVoicemail,
  faGamepad,
  faVideo,
  faRobot,
  faCaretDown,
  faArrowRight,
  faArrowLeft,
  faPlus,
  faPlaySolid,
  faPauseSolid,
  faTransgender,
  faMusic,
  faBars,
  faGlobe,
  faLongArrowAltRightSolid,
  faLongArrowAltLeftSolid,
  faLongArrowAltUpSolid,
  faLongArrowAltDownSolid,
  faFileUpload,
  faHeartSolid,
  faEllipsisHSolid,
  faCircle,
  faCircleSolid,
  faDollarSign,
  faMicrophoneAlt,
  faInbox,
  faEye,
  faEuroSign,
  faShare,
  faStarSolid,
  faShoppingBasket,
  faTrash,
  faSearch,
  faDownload,
  faSortAmountDown,
  faSlidersH,
  faAngleDoubleRight,
  faFlag,
  faCcVisa,
  faCcMastercard,
  faCcDiscover,
  faCcAmex,
  faCcPaypal,
  faArrowUpSolid,
  faArrowUp,
  faArrowDown,
  faRedo,
  faExternalLink,
  faSignOut,
  faSignIn,
  faSpinnerThird,
  faThList,
  faThLarge,
  faCircleCheck,
  faWrenchSolid,
  faSave,
  faPencil,
  faUserAstronaut,
  faUserSecret,
  faFireSolid,
  faChevronDown,
  faChevronUp,
  faCog,
  faChildSolid
)
